"use client";

import React from "react";
import { Mail } from "lucide-react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface QuoteBannerCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
  note: string;
}
const copyData: Record<Lang, QuoteBannerCopy> = {
  en: {
    eyebrow: "Industrial Wire Mesh Specifications",
    heading: "Get Custom Mesh Specifications and Technical Pricing",
    lead: "Send us your wire diameter, weave type, micron rating, or application parameters. Our engineering team confirms manufacturing tolerances and formal quotes for your order.",
    secondaryLabel: "Contact Our Engineers",
    note: "Manufactured to ASTM E2016 and ISO 9044 industrial wire cloth standards"
  },
  zh: {
    eyebrow: "工业金属丝网技术规范",
    heading: "获取定制丝网技术规格与工程报价",
    lead: "提供您的丝径、编织类型、微米过滤精度或应用工况参数。我们的工程团队为您核实制造公差并提供正式报价。",
    secondaryLabel: "咨询工程师",
    note: "生产全面遵循 ASTM E2016 与 ISO 9044 工业丝网制造标准"
  },
  es: {
    eyebrow: "Especificaciones de malla metálica industrial",
    heading: "Obtenga especificaciones de malla personalizadas y cotización técnica",
    lead: "Envíenos su diámetro de alambre, tipo de tejido, micraje o parámetros de aplicación. Nuestro equipo técnico confirma las tolerancias y presupuestos formales.",
    secondaryLabel: "Contactar con ingenieros",
    note: "Fabricado según las normas de tela metálica industrial ASTM E2016 e ISO 9044"
  },
  de: {
    eyebrow: "Spezifikationen für Industriedrahtgewebe",
    heading: "Kundenspezifische Gewebespezifikationen und technisches Angebot anfordern",
    lead: "Senden Sie uns Drahtdurchmesser, Webart, Mikronwert oder Einsatzbedingungen. Unser Fachteam prüft Ihre Fertigungstoleranzen und erstellt ein verbindliches Angebot.",
    secondaryLabel: "Ingenieure kontaktieren",
    note: "Hergestellt nach den Industriedrahtgewebe-Normen ASTM E2016 und ISO 9044"
  },
  fr: {
    eyebrow: "Spécifications des toiles métalliques industrielles",
    heading: "Obtenez des spécifications sur mesure et un devis technique",
    lead: "Transmettez votre diamètre de fil, type de tissage, micronage ou paramètres d'application. Notre équipe technique valide vos tolérances et établit votre devis.",
    secondaryLabel: "Consulter nos ingénieurs",
    note: "Fabrication conforme aux normes de toiles métalliques industrielles ASTM E2016 et ISO 9044"
  },
  pt: {
    eyebrow: "Especificações de malha metálica industrial",
    heading: "Obtenha especificações personalizadas e cotação técnica para sua malha",
    lead: "Envie-nos diâmetro de fio, tipo de tecelagem, micragem ou condições de operação. Nossa equipe técnica valida as tolerâncias e apresenta um orçamento formal.",
    secondaryLabel: "Falar com engenheiros",
    note: "Fabricado conforme os padrões industriais de tela metálica ASTM E2016 e ISO 9044"
  }
};
export default function QuoteBanner() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, copyData);
  return <CtaBand id="quotectabanner" eyebrow={content.eyebrow} heading={content.heading} lead={content.lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: content.secondaryLabel,
    to: "/ContactPage",
    icon: Mail
  }} note={content.note} />;
}